import React, { useMemo, useRef } from "react";
import ReactQuill, { Quill } from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { ImageResize } from "quill-image-resize-module-ts";
import "../../../admin_resources/css/font.css";

// Quill에 이미지 리사이즈 모듈 등록
if (typeof window !== "undefined" && window.Quill) {
  window.Quill = Quill;
}
Quill.register("modules/ImageResize", ImageResize);

// 1. Quill Font 설정 확장
const Font = Quill.import("formats/font");

// 사용할 폰트 추가
Font.whitelist = ["NanumGothic", "DotEum", "BaTang", "Gullim", "Gungseo"]; // 여기에 폰트 이름 추가
Quill.register(Font, true);

const Align = Quill.import("attributors/style/align");
Quill.register(Align, true);

const ReactQuillModul = ({ editorValue, onChangeEditorValue }) => {
  const quillRef = useRef(null);

  const formats = [
    "font",
    "size",
    "color",
    "background",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "indent",
    "link",
    "image",
    "align",
  ];

  const toolbarOptions = [
    [{ font: Font.whitelist }], // 툴바에 폰트 추가
    [{ size: ["small", false, "large", "huge"] }],
    [{ color: [] }, { background: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    ["link", "image"],
  ];

  const handleImageUpload = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const formData = new FormData();
      formData.append("image", file);

      try {
        const response = await fetch("/upload/image", {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          const quill = quillRef.current.getEditor(); // ReactQuill 인스턴스
          const range = quill.getSelection(); // 현재 커서 위치
          quill.insertEmbed(range.index, "image", data.url); // 반환된 URL로 이미지 삽입
        } else {
          alert("이미지 업로드에 실패했습니다.");
        }
      } catch (error) {
        console.error("이미지 업로드 에러:", error);
      }
    };
  };

  // Quill 모듈 설정
  const modules = useMemo(
    () => ({
      toolbar: {
        container: toolbarOptions,
        handlers: {
          image: handleImageUpload, // 이미지 버튼 클릭 시 업로드 함수 호출
        },
      },
      ImageResize: {
        modules: ["Resize", "DisplaySize", "Toolbar"], // 리사이즈 및 툴바 표시 모듈 활성화
        onResize: (image, newWidth, newHeight) => {
          // 이미지 크기 변경 시 스타일 설정
          image.setAttribute(
            "style",
            `width: ${newWidth}px !important; height: ${newHeight}px !important;`
          );
        },
      },
    }),
    []
  );

  // Quill에서 HTML 출력 시 변경된 이미지를 포함한 데이터를 확인
  	const handleEditorChange = (content, delta, source, editor) => {
    const html = editor.getHTML(); // Quill의 HTML 출력
    onChangeEditorValue(html); // 부모 컴포넌트로 HTML 데이터 전달
  // console.log("HTML 출력:", html); // 디버깅용 로그
  };

  return (
    <ReactQuill
      ref={quillRef}
      style={{ height: "600px", margin: "4px" }}
      value={editorValue} // 초기값 설정
      modules={modules} // 수정된 모듈 설정
      formats={formats} // 사용 가능한 형식
      onChange={handleEditorChange} // 변경 시 콜백 호출
    />
  );
};

export default ReactQuillModul;
